//responseCode 响应码
if (typeof ResponseCode == "undefined") {
    var ResponseCode = {};
    ResponseCode.success = 0;
    ResponseCode.failure = 1 << 1;
    ResponseCode.unresponse = 1 << 2;
    ResponseCode.unknown = 1 << 3
}

function get() {
//10.1.13.238:8080
}

//url 请求地址 parameters 请求参数 callback 回调函数(responseCode, message)
function post(url, parameters, callback) {
    getToKen(3, function (responseCode, message) {
        var status = 200
        if (responseCode === ResponseCode.success) {
            fetch(url, {
                method: "POST",
                body: JSON.stringify(parameters),
                headers: {
                    "Content-type": "application/json; charset=UTF-8",
                    "token": message
                }
            })
                .then(response => {
                    status = response.status
                    return response.text()
                })
                .then(function (json) {
                    if (typeof callback === "function") {
                        if (status === 200) {
                            callback(ResponseCode.success, json)
                        } else {
                            callback(ResponseCode.failure, json)
                        }
                    }
                })
        } else if (responseCode === ResponseCode.failure) {
            callback(ResponseCode.failure, "验证码服务器错误")
        } else if (responseCode === ResponseCode.unresponse) {
            callback(ResponseCode.unresponse, "验证码获取为空")
        } else {
            callback(ResponseCode.unknown, "未知错误")
        }
    })
}

//#undo
//count 迭代次数 callback 回调函数(responseCode, message, identifier)
function enumPost(url, parameters, identifier, callback) {
    getToKen(3, function (responseCode, message) {
        var status = 200
        if (responseCode === ResponseCode.success) {
            fetch(url, {
                method: "POST",
                body: JSON.stringify(parameters),
                headers: {
                    "Content-type": "application/json; charset=UTF-8",
                    "token": message
                }
            })
                .then(response => {
                    status = response.status
                    return response.text()
                })
                .then(function (json) {
                    if (typeof callback === "function") {
                        if (status === 200) {
                            callback(ResponseCode.success, json, identifier)
                        } else {
                            callback(ResponseCode.failure, json, identifier)
                        }
                    }
                })
        } else if (responseCode === ResponseCode.failure) {
            callback(ResponseCode.failure, "验证码服务器错误", identifier)
        } else if (responseCode === ResponseCode.unresponse) {
            callback(ResponseCode.unresponse, "验证码获取为空", identifier)
        } else {
            callback(ResponseCode.unknown, "未知错误", identifier)
        }
    })
}

function fetchUrl(appendUrl) {
  //https://rcrmyy.wanjiadayuan.com:877
    return "https://rcrmyy.wanjiadayuan.com:877/" + appendUrl
    // return "http://10.1.13.238:8080/" + appendUrl
}

//count 迭代次数 callback 回调函数(responseCode, message)
function getToKen(count, callback) {
    var status = 200
    fetch(fetchUrl('/login'), {
        method: "POST",
        body: JSON.stringify({
            enterpriseDl: 'softmanagetoolandroid',
            enterpriseMm: 'a779bd501ee311e9ab9600505690132d'
        }),
        headers: {
            "Content-type": "application/json; charset=UTF-8"
        }
    })
        .then(response => {
            status = response.status
            return response.text()
        })
        .then(function (message) {
            if (typeof callback === "function") {
                if (status === 200) {
                    if (message !== "") {
                        callback(ResponseCode.success, message)
                    } else if (count === 1) {
                        message = "验证码获取为空"
                        callback(ResponseCode.unresponse, message)
                    } else {
                        //迭代
                        getToKen(count - 1, callback)
                    }
                } else {
                    callback(ResponseCode.failure, message)
                }
            }
        })
}


export {
  post,
  fetchUrl
}



// WEBPACK FOOTER //
// ./src/assets/js/network.js